<template>
    <float-bottom class="c-jhs-free-graduation-btn-float-bottom">
        <div @click="isActive ? goToPayment() : ''" class="c-jhs-free-graduation-btn-float-bottom-btn" data-jest="apply-link">
            <img :src="buildImgUrl(isActive ? 'jhsfree_graduation_btn_active.png' : 'jhsfree_graduation_btn_inactive.png')" alt="有料会員になる">
        </div>
    </float-bottom>
</template>

<script>
import FloatBottom from "../atoms/FloatBottom.vue";
import {getClickAllEvent} from "../../util/Ga4EventUtil";
import {mapGetters} from "vuex";
import * as urlUtil from "../../util/UrlUtil";

export default {
    name: "JhsFreeLpBtnFloatBottom",
    components: {FloatBottom},
    props: {
        isActive: {
            type: Boolean,
            required: true
        },
    },
    computed: {
        ...mapGetters({
            accountStatus: 'AccountStoreV2/accountStatus'
        }),
    },
    methods: {
        transitionPage(nextUrl) {
            location.href = nextUrl
        },
        /*
         * GA4イベントを送信し次のページへ遷移させる
         */
        goToPayment() {
            const nextUrl = urlUtil.servletUrlUtil.paymentBaseUrl();
            // ボタンテキストが打ち文字でなく画像なのでBtnコンポーネントにtextを渡せないため
            // こちらでclick_allを送信し次のページへ遷移させる
            getClickAllEvent(nextUrl, '有料会員になる')

            this.transitionPage(nextUrl);
        },
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.buildS3ImageUrl('img/jhs-free/graduation/' + imgName)
        },
    }
}
</script>

<style lang="scss" scoped>
@use "sass:math";

// ベースとなるデバイス幅
$grid-device-width: 375px;
// 余白
$grid-base: percentage(math.div(16px, $grid-device-width)); // 16px
$grid-consistent: $grid-base * 0.5; // 8px
.c-jhs-free-graduation-btn-float-bottom {
    &-btn {
        display: block;

        img {
            height: 100%;
        }
    }

    :deep(.c-float-bottom-background) {
        border-top: none;
        background: transparent;
        margin: 0 (-$grid-consistent);
        padding: 0;
    }
}
</style>
